import { Center, Loader } from '@mantine/core'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

/** UX guards only; the server is the authority on every request. */
export function RequireAuth() {
  const status = useSelector((s) => s.auth.status)
  const enrolled = useSelector((s) => s.auth.mfa.enrolled)
  const location = useLocation()
  if (status === 'loading') {
    return (
      <Center h="60vh">
        <Loader />
      </Center>
    )
  }
  if (status === 'anon') return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (status === 'mfa') return <Navigate to={enrolled ? '/login/verify' : '/security/setup'} replace />
  return <Outlet />
}

export const homeFor = (role) => (role === 'agent' ? '/agent' : '/admin')

export function RequireRole({ roles }) {
  const user = useSelector((s) => s.auth.user)
  if (!user) return null
  return roles.includes(user.role) ? <Outlet /> : <Navigate to={homeFor(user.role)} replace />
}

export function RequirePermission({ permission, children }) {
  const allowed = useSelector((s) => !!s.auth.user && s.auth.user.permissions.includes(permission))
  return allowed ? children : null
}
